import { FC } from 'react'
import { StackedCell, useModal } from '../../../../../../components'
import { getAtendimentoById } from '../../../../atendimento/core/_requests'
import { AtendimentoBase } from '../../../../atendimento/core/_models'
import { AtendimentoDetalheModal } from '../../components/modal/AtendimentoDetalheModal'
import { useT } from '_metronic/i18n/Metronici18n'

type Props = {
  atendimento?: AtendimentoBase
  /** Visão do responsável/profissional (detalhe sem dados internos do financeiro). */
  isResponsavel?: boolean
}

/**
 * Protocolo como botão (abre o detalhe do atendimento) — antes era um <span onClick>, sem
 * teclado nem nome acessível. Especialidade como linha de apoio. Usado nas telas de itens de
 * fatura (financeiro e profissional).
 */
export const ProtocoloAtendimentoCell: FC<Props> = ({ atendimento, isResponsavel = false }) => {
  const { t } = useT()
  const { showModal } = useModal()

  const abrirDetalhe = () =>
    showModal({
      title: t('modal.atendimento_detalhe'),
      content: <AtendimentoDetalheModal isResponsavel={isResponsavel} />,
      fetchers: {
        atendimento: () => getAtendimentoById(atendimento?.id),
      },
    })

  return (
    <StackedCell
      tabular
      primary={
        atendimento?.protocolo ? (
          <button
            type='button'
            className='btn btn-link p-0 fw-semibold text-primary text-decoration-underline'
            onClick={abrirDetalhe}
            aria-label={`Ver detalhes do atendimento ${atendimento.protocolo}`}
          >
            {atendimento.protocolo}
          </button>
        ) : undefined
      }
      secondary={atendimento?.especialidade?.nome}
    />
  )
}
